<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getJobs"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-2">Job</div>
        <div class="col-md-3">Device</div>
        <div class="col-md-2">Client</div>
        <div class="col-md-5">Requisitions</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-2 my-auto">
          <span class="bg-primary text-white px-1">{{
            slotProps.item.job_number
          }}</span>
          <p class="m-0">
            {{
              moment
                .duration(
                  moment(Date.now()).diff(
                    moment(new Date(slotProps.item.created_at)),
                    "seconds"
                  ),
                  "seconds"
                )
                .format("D[d], H[h &] m[m]")
            }}
            ago
          </p>
          <small v-if="slotProps.item.client_reference">
            {{ slotProps.item.client_reference }}
          </small>
          <small
            v-if="
              slotProps.item.job_reference && !slotProps.item.client_reference
            "
          >
            {{ slotProps.item.job_reference }}
          </small>
        </div>

        <div class="col-md-3 my-auto">
          <p class="m-0">{{ slotProps.item.manufacture.description }}</p>
          <p class="m-0">
            {{ slotProps.item.device_type.code }} -
            <span v-if="slotProps.item.device_model">{{
              slotProps.item.device_model.description
            }}</span>
            <span v-if="!slotProps.item.device_model && slotProps.item.model">{{
              slotProps.item.model
            }}</span>
          </p>
          <p class="m-0" v-if="slotProps.item.imei_in">
            {{ slotProps.item.imei_in }}
          </p>
          <p class="m-0" v-if="!slotProps.item.imei_in">
            {{ slotProps.item.serial_in }}
          </p>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0" v-if="slotProps.item.partner_id != null">
            [{{ slotProps.item.partner.name }}]
          </p>
          <p class="m-0" v-if="slotProps.item.client_id != null">
            {{
              slotProps.item.client.name + " " + slotProps.item.client.surname
            }}
          </p>
          <p class="m-0" v-if="slotProps.item.client_id != null">
            {{ slotProps.item.client.contact_number }}
          </p>
          <p class="m-0" v-if="slotProps.item.client_id == null">
            {{ slotProps.item.partner.contact_number }}
          </p>
        </div>

        <div class="col-md-5 my-auto">
          <span
            v-for="req in slotProps.item.job_part_requisitions"
            :key="req.id"
          >
            <table class="table table-sm mb-1 table-bordered">
              <tr>
                <td>
                  <span
                    v-b-tooltip.hover
                    style="cursor: pointer"
                    title="Print"
                    @click="
                      vWindow.open(
                        `/pdf/reports/inventory/requisition/${req.id}?cid=${req.company_id}`
                      )
                    "
                    class="text-info table-action-icon"
                  >
                    <i class="lni lni-printer"></i>
                  </span>

                  <strong>
                    {{
                      moment
                        .duration(
                          moment(Date.now()).diff(
                            moment(new Date(req.created_at)),
                            "seconds"
                          ),
                          "seconds"
                        )
                        .format("D [day], H [hour &] m [min]")
                    }}
                    ago
                  </strong>
                </td>
                <td class="border-0">
                  <strong>Required</strong>
                </td>
                <td class="border-0">
                  <strong>On Hand</strong>
                </td> 
                <td class="border-0">
                  <strong>On Order</strong>
                </td>                
              </tr>
              <tr
                v-for="p in req.job_part_requisition_items"
                :key="p.id"
                class="l-h-1"
              >
                <td>
                  <p class="m-0 p-0 text-body">{{ p.part.code }}</p>
                  <small class="m-0 p-0 text-muted">{{
                    p.part.description
                  }}</small>
                </td>
                <td>
                  {{ p.quantity }}
                </td>
                <td>
                  <p
                    :class="{
                      'text-success': p.part.on_hand >= p.quantity,
                      'text-danger': p.part.on_hand < p.quantity,
                    }"
                  >
                    {{ p.part.on_hand }}
                  </p>
                </td>
                <td>
                  {{ p.part.on_order }}
                </td>
               
              </tr>
              <tr></tr>
              <tr>
                <td colspan="4">
                  <b-button
                    variant="primary"
                    class="btn-sm"
                    v-if="canIssue(req)"
                    @click="issue(req.id)"
                  >
                    Issue
                  </b-button>

                  <div v-for="order in slotProps.item.orders" :key="order.id">
                    <span v-if="order.job_part_requisition_id == req.id"
                      >
                       <span
                    v-b-tooltip.hover
                    style="cursor: pointer"
                    title="Print"
                    @click="
                      vWindow.open(
                        `/pdf/reports/inventory/order/${order.id}?cid=${req.company_id}`
                      )
                    "
                    class="text-info table-action-icon"
                  >
                    <i class="lni lni-printer"></i>
                  </span>

                      Order# <strong> {{ order.order_number }}</strong> -
                      {{ order.supplier.name }}</span
                    >
                  </div>

                  <div
                    class="row"
                    v-if="canOrder(slotProps.item, req) && !orderCreating"
                  >
                    <div class="col-auto">
                      <b-button
                        variant="info"
                        class="btn-sm ml-2 text-white"
                        @click="order(req)"
                      >
                        Order
                      </b-button>
                    </div>
                    <div class="col">
                      <b-form-select v-model="selectedSupplier">
                        <b-form-select-option
                          v-for="supplier in suppliers"
                          :value="supplier"
                          :key="supplier.id"
                          >{{ supplier.name }}</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </span>
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="xl"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'jobs-awaiting-allocation' })"
      :lazy="true"
    >
      <router-view @awaitingAllocationCreated="awaitingAllocationCreated()">
      </router-view>
    </b-modal>
  </div>
</template>

<script>
import orderRepo from "@/api/repos/orderRepo";
import jobRepo from "@/api/repos/jobRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      orderCreating: false,
      selectedSupplier: {},
      suppliers: [],
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "id", label: "Job Desc", order: "desc" },
      sortOptions: [
        { column: "id", label: "Job Asc", order: "asc" },
        { column: "id", label: "Job Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getSuppliers();
    this.getJobs({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      search: "",
    });
  },
  methods: {
    async getSuppliers() {
      let { data } = await orderRepo.createRelatedData();
      this.suppliers = data.suppliers;
      this.selectedSupplier = this.suppliers[0];
    },
    async getJobs(e) {
      this.isLoad = true;

      try {
        let { data } = await jobRepo.partsRequisition(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.jobs.data;
        this.totalRows = data.jobs.total;
        this.page = data.jobs.current_page;
        this.fromRow = data.jobs.from;
        this.toRow = data.jobs.to;
        this.lastPage = data.jobs.last_page;

        this.filterOptions = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    canIssue(req) {
      if (req.fulfilled) {
        return false;
      }

      let onHand = true;
      req.job_part_requisition_items.forEach((x) => {
        if (x.part.on_hand < x.quantity) {
          onHand = false;
        }
      });
      return onHand;
    },

    canOrder(job, req) {
      let canOrder = true;
      job.orders.forEach((x) => {
        if (x.job_part_requisition_id == req.id) {
          canOrder = false;
        }
      });

      let onHand = true;
      req.job_part_requisition_items.forEach((x) => {
        if (x.part.on_hand < x.quantity) {
          onHand = false;
        }
      });

      if (onHand == false && canOrder) {
        return true;
      } else {
        return false;
      }
    },
    async issue(id) {
      this.isLoad = true;
      try {
        await jobRepo.partsRequisitionIssue(id);
      } catch (error) {
        console.log(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          console.log(this.errors);
          this.$root.$bvToast.toast("Errors", {
            title: "Something went wrong",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } finally {
        this.getJobs({
          sort: this.sort,
          filters: null,
          page: this.page,
          rowsPerPage: localStorage.getItem("rowsPerPage")
            ? localStorage.getItem("rowsPerPage")
            : 10,
          search: "",
        });
      }
    },

    async order(req) {
      this.orderCreating = true;
      this.isLoad = true;
      let order = {};

      order.supplier_id = this.selectedSupplier.id;
      order.job_part_requisition_id = req.id;
      order.job_id = req.job_id;
      order.parts = [];

      req.job_part_requisition_items.forEach((x) => {
        if (x.part.on_hand < x.quantity) {
          order.parts.push({
            id: x.part.id,
            quantity: x.quantity - x.part.on_hand,
          });
        }
      });

      try {
        await orderRepo.create(order);
      } catch (error) {
        console.log(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          console.log(this.errors);
          this.$root.$bvToast.toast("Form Errors", {
            title: "Errors on form data",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } finally {
        this.orderCreating = false;
        this.getJobs({
          sort: this.sort,
          filters: null,
          page: this.page,
          rowsPerPage: localStorage.getItem("rowsPerPage")
            ? localStorage.getItem("rowsPerPage")
            : 10,
          search: "",
        });
      }
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
